import React from 'react';
import PropTypes from 'prop-types';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import useStyle from './useStyle';

const DataTable = ({ data, onRowClick }) => {
  const classes = useStyle;
  return (
    <TableContainer component={Paper}>
      <Table className={classes.table} aria-label="simple table">
        <TableHead>
          <TableRow>
            <TableCell>Transacción</TableCell>
            <TableCell>Descripción</TableCell>
            <TableCell align="right">Monto</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {data.map((row, index) => (
            <TableRow hover key={`${row.txn_code}_${index + 1}`} onClick={() => onRowClick(index)}>
              <TableCell>{row.txn_code}</TableCell>
              <TableCell>{row.txn_name}</TableCell>
              {row.minimum_amount && (
                <TableCell align="right">{row.minimum_amount}</TableCell>
              )}
              {row.maximum_amount && (
                <TableCell align="right">{row.maximum_amount}</TableCell>
              )}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

DataTable.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  data: PropTypes.array.isRequired,
  onRowClick: PropTypes.func.isRequired,
};

export default DataTable;
